<template>
  <button class="q-toggle" :class="{on: on, disabled: disabled}" :disabled="disabled" @click="onClick">
  </button>
  <!-- <button  :class="{on: on}" :disabled="disabled" @click.native="onClick"></button> -->
</template>
<script>
/**
 * Qnap style toggle
 */
export default {
  name: 'toggle',
  props: {
    on: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClick () {
      if (!this.disabled) {
        this.$log.info('click')
        this.$emit('update:on', !this.on)
      }
    }
  }
}
</script>
<style lang="scss">
.q-toggle {
  cursor: pointer;
  z-index: 10;
  padding: 0;
  border: 0;
  background-color: transparent;
  width: 34px;
  height: 20px;
  // display: inline-block;
  vertical-align: middle;
  background-image: url("../../assets/toggle/off.svg");
  &.on {
    background-image: url("../../assets/toggle/on.svg");
  }
  &:disabled.on {
    cursor: default;
    background-image: url("../../assets/toggle/on_disable.svg");
  }
  &:disabled {
    cursor: default;
    background-image: url("../../assets/toggle/off_disable.svg");
  }
  &:focus {
    outline: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/module/Toggle.vue